"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicKeyIdentity = exports.Identity = void 0;
class Identity {
    async getProtectedHeader() {
        return new Map();
    }
    async getUnprotectedHeader(cborMessageContent, cborProtectedHeader) {
        return new Map();
    }
}
exports.Identity = Identity;
class PublicKeyIdentity extends Identity {
}
exports.PublicKeyIdentity = PublicKeyIdentity;
